import { Component, OnInit } from '@angular/core';
import { SettingsComponent } from '../settings/settings.component';
import { ModalController, AnimationController, NavController } from '@ionic/angular';
import { NotificationsService } from '../../services/notifications.service';
import { LedgerService } from 'src/app/services/ledger.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  balance = 0;
  unsub1;
  constructor(
    public modalController: ModalController,
    public animationCtrl: AnimationController,
    public navController: NavController,
    public notificationsService: NotificationsService,
    public ledgerService: LedgerService
  ) {
    this.unsub1 = this.ledgerService.ledgerUpdate.subscribe(async (ledger) => { this.calcBalance(ledger); });
  }

  ngOnInit() { }


  calcBalance(ledger) {
    ledger = ledger ? ledger : this.ledgerService.ledger;
    this.balance = ledger?.balance || 0;
  }

  openSearch() {
    this.navController.navigateForward('/search');
  }

  async presentSettingsModal() {
    const enterAnimation = (baseEl: any) => {
      const root = baseEl.shadowRoot;

      const backdropAnimation = this.animationCtrl.create()
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .addElement(root.querySelector('ion-backdrop')!)
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = this.animationCtrl.create()
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .addElement(root.querySelector('.modal-wrapper')!)
        .keyframes([
          { offset: 0, opacity: '0', transform: 'scale(0)' },
          { offset: 1, opacity: '0.99', transform: 'scale(1)' }
        ]);

      return this.animationCtrl.create()
        .addElement(baseEl)
        .easing('ease-out')
        .duration(500)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };

    const leaveAnimation = (baseEl: any) => enterAnimation(baseEl).direction('reverse');

    const modal = await this.modalController.create({
      component: SettingsComponent,
      enterAnimation,
      leaveAnimation
    });
    return await modal.present();
  }

  ionviewDidLeave() {
    this.unsub1.unsubscribe();
  }
}
